export const BASE_URL = "https://development-api.hapimag.com";

export const API_LOGSTASH_SPA = "/spa";

export const API_APARTMENT_SEARCH = "/apartment-search";
export const API_APARTMENT_SEARCH_VERSION = "/v3";
export const API_APARTMENT = "/apartment/";
export const API_ADD_APARTMENT = "/add-apartment";
export const API_APARTMENT_SEARCH_RESORTS_SEARCH = "/free_resorts";
export const API_APARTMENT_SEARCH_RESORTS = "/resorts";
export const API_APARTMENT_SEARCH_APARTMENT_CATEGORIES = "/apartment_categories";
export const API_APARTMENT_SEARCH_ALTERNATIVES = "/alternatives";
export const API_APARTMENT_SEARCH_CHEAPEST_APARTMENT_PRICE = API_APARTMENT_SEARCH_RESORTS_SEARCH + "/cheapest_apartment";
export const API_APARTMENT_SEARCH_AVAILABILITY = "/availability";
export const API_APARTMENT_SEARCH_AVAILABILITY_PER_RESORT = API_APARTMENT_SEARCH_AVAILABILITY + "/resort";

export const API_CONSENT_MANAGEMENT = "/consent-management";
export const API_CONSENT_MANAGEMENT_VERSION = "/v2";
export const API_CONSENT_MANAGEMENT_VERSION_MYSQL = "/v3";
export const API_CONSENT_MANAGEMENT_TERMS_OF_USE = "/share-marketplace/terms-of-use";

export const API_SHARE_MARKETPLACE = "/share-marketplace-gateway";
export const API_SHARE_MARKETPLACE_VERSION_LEGACY = "/v4";
export const API_SHARE_MARKETPLACE_VERSION = "/v5";
export const API_SHARE_MARKETPLACE_RIGHTS_SELL_SHARES = "/sellables/sell-rights";
export const API_SHARE_MARKETPLACE_SELLABLES_SHARES_POINTS = "/sellables/shares-points";
export const API_SHARE_MARKETPLACE_OFFERS = "/offers";
export const API_SHARE_MARKETPLACE_MY_REQUESTS = API_SHARE_MARKETPLACE_OFFERS + "/requested";
export const API_SHARE_MARKETPLACE_OFFERS_SELLERS = "/sellers";
export const API_SHARE_MARKETPLACE_OFFERS_BUYERS = "/buyers";
export const API_SHARE_MARKETPLACE_OFFERS_HISTORY = "/history";
export const API_SHARE_MARKETPLACE_OFFERS_CONTACT = "/contact";
export const API_SHARE_MARKETPLACE_OFFERS_RESERVATION = "/reservation";
export const API_SHARE_MARKETPLACE_OFFERS_REVOKE = "/revoke";
export const API_SHARE_MARKETPLACE_OFFERS_FINALISE = "/finalise";
export const API_SHARE_MARKETPLACE_OFFERS_DEACTIVATION = "/deactivation";
export const API_SHARE_MARKETPLACE_OFFERS_REQUESTS = "/requests";
export const API_SHARE_MARKETPLACE_OFFERS_REQUESTS_DECLINE = API_SHARE_MARKETPLACE_OFFERS_REQUESTS + "/decline";
export const API_SHARE_MARKETPLACE_OFFERS_REQUESTS_WITHDRAW = API_SHARE_MARKETPLACE_OFFERS_REQUESTS + "/withdraw";
export const API_SHARE_MARKETPLACE_OFFERS_REQUESTS_REMOVE = API_SHARE_MARKETPLACE_OFFERS_REQUESTS + "/remove";
export const API_SHARE_MARKETPLACE_OFFERS_COUNTRIES = "/countries";
export const API_SHARE_MARKETPLACE_OFFERS_COUNT = "/count/per_share_price";
export const API_SHARE_MARKETPLACE_ADMIN_OFFERS = "/admin/offers";
export const API_SHARE_MARKETPLACE_RIGHTS_CONTACT_SELLER = "/sellables/contact-seller-rights";
export const API_SHARE_MARKETPLACE_MEMBER_DETAILS = "/members/details";
export const API_SHARE_MARKETPLACE_SHARES_AVERAGE_PRICE = "/shares/price/average";
export const API_SHARE_MARKETPLACE_SHARES_MEDIAN_PRICE = "/shares/price/median";

export const API_BOOKING_GATEWAY = "/booking-gateway";
export const API_BOOKING_GATEWAY_VERSION = "/v3";
export const API_BOOKING = "/booking";
export const API_BOOKING_REPLACE = API_BOOKING + "/replace";
export const API_BOOKING_REVIEW = API_BOOKING + "/review";
export const API_BOOKING_EMAIL = API_BOOKING + "/email";
export const API_BOOKING_EMAIL_GUEST = API_BOOKING_EMAIL + "/guest";
export const API_CURRENCY_CONVERSION = "/currency_conversion";
export const API_RESERVATIONS_ADMIN = "/admin/reservations";
export const API_RESERVATIONS = "/reservations";
export const API_RESERVATIONS_ARRIVAL_CARD = "/arrival-card";
export const API_RESERVATIONS_CONTACT_HOST = "/contact-host";
export const API_RESERVATIONS_GUESTS = "/guests";
export const API_RESERVATIONS_PROGRESS_STATUS = "/progress-status";

export const API_PREARRIVAL = "/pre-arrival";
export const API_PREARRIVAL_CO_TRAVELLER = "/co-traveller";
export const API_PREARRIVAL_CO_TRAVELLERS = "/co-travellers";
export const API_PREARRIVAL_SAVE = "/save";

export const API_WAITING_LIST = "/waiting-list";
export const API_WAITING_LIST_EXTRA_APARTMENTS = "/extra-apartments";
export const API_WAITING_LIST_UPSERT = "/upsert";
export const API_WAITING_LIST_WITH_BOOKABLE = "/with-bookable";
export const API_WAITING_LIST_DECLINE = "/decline";
export const API_WAITING_LIST_CAN_ENTER = "/can-enter";

export const API_USER_ACCOUNTS = "/user-accounts";
export const API_USER_ACCOUNTS_VERSION = "/v3";
export const API_USERS = "/users";
export const API_USER_SETTINGS = "/settings";
export const API_USER_BANK_ACCOUNTS = "/bank-accounts";
export const API_USER_RESET_PASSWORD = "/reset_password";
export const API_USER_TERMS_CONDITIONS = "/terms-and-conditions/accept";
export const API_USER_CONVERT_TRIAL = "/trial_user";
export const API_LEADS = "/leads";
export const API_DISQUS_SIGNATURE = "/disqus/signature";
export const API_USER_BOOKING_STATUS = "/booking-status";
export const API_USER_ONLINE_ACCOUNT = "/online-account";
export const API_USER_ONLINE_ACCOUNT_VERIFICATION = API_USER_ONLINE_ACCOUNT + "/verification";
export const API_USER_ONLINE_ACCOUNT_CREATION = API_USER_ONLINE_ACCOUNT + "/creation";

export const API_PAYMENTS = "/payments";
export const API_PAYMENTS_VERSION = "/v2";
export const API_SAFERPAY = "/saferpay";
export const API_INITIALIZE_PAYMENT = "/initialize-payment";

export const API_CUSTOMER_PRODUCTS = "/customer-products";
export const API_CUSTOMER_PRODUCTS_VERSION_LEGACY = "/v3";
export const API_CUSTOMER_PRODUCTS_VERSION = "/v4";
export const API_RESIDENCE_POINTS = "/residence-points";
export const API_RESIDENCE_POINTS_SUMMARY = "/summary";
export const API_RESIDENCE_POINTS_NOT_AVAILABLE = "/unavailable";
export const API_RESIDENCE_POINTS_FOR_SALE = "/for-sale";
export const API_RESIDENCE_POINTS_MOVEMENTS = "/movement";
export const API_RESIDENCE_POINTS_TRANSFERS = "/transfers";
export const API_LOYALTY_PROGRAM = "/loyalty-program";
export const API_PRODUCTS = "/products";
export const API_POINTS_PLATFORM = "/points-platform";
export const API_POINTS_PLATFORM_OFFER = API_POINTS_PLATFORM + "/offer";
export const API_POINTS_PLATFORM_OFFER_SEARCH = API_POINTS_PLATFORM_OFFER + "/search";
export const API_POINTS_PLATFORM_OFFER_PURCHASE = API_POINTS_PLATFORM_OFFER + "/purchase";
export const API_POINTS_PLATFORM_CANCEL = "/cancel";
export const API_POINTS_PLATFORM_ACCESS = "/access";
export const API_POINTS_PLATFORM_CONFIGURE = "/configure";

export const API_CUSTOMER_DOCUMENTS = "/customer-documents";
export const API_CUSTOMER_DOCUMENTS_VERSION = "/v2";
export const API_CUSTOMER_DOCUMENTS_LIST = "/documents";
export const API_CUSTOMER_DOCUMENTS_LIST_ADMIN = "/documents_customer";
export const API_CUSTOMER_DOCUMENT_TYPES_LIST = "/document-types";
export const API_CUSTOMER_DOCUMENT_STREAM = "/document/stream";
export const API_CUSTOMER_DOCUMENT_SET_AS_READ = "/set-as-read";

export const API_INVOICES = "/invoices";

export const API_DIRECT_DEBIT_SETTINGS = "/direct-debit-settings";
export const API_DIRECT_DEBIT_SETTINGS_CANCEL = API_DIRECT_DEBIT_SETTINGS + "/cancel";
export const API_DIRECT_SALES = "/direct-sales";
export const API_DIRECT_SALES_PRICING = API_DIRECT_SALES + "/pricing";

export const CONTENTFUL_BASE_URL = "https://graphql.contentful.com/content/v1/spaces/";
export const GOOGLE_MAPS_EMBED_BASE_URL = "https://www.google.com/maps/embed/v1/place";
export const GOOGLE_MAPS_STATIC_BASE_URL = "https://maps.googleapis.com/maps/api/staticmap";
export const GOOGLE_MAPS_API_KEY = "AIzaSyAsoqwIWT55iJkpr8Y7rICtmk28xyJ7UBk";
export const GOOGLE_reCAPTCHA_V2_SITE_KEY = "6LeVaRAnAAAAABlXYDpq35zCSdtAEcdF1x1eGrtP";
